import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {IPartner} from 'types/partners';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {Trans, useTranslation} from 'react-i18next';
import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Panel from 'components/Panel';
import ReferenceItems from 'features/layout/CommonPage/panels/ReferencesPanel/ReferenceItems';
import React from 'react';
import {IDiplomatObject} from 'types/DiplomatObject';
import {
   partnerRefLabel,
   NO_PARTNER_REFS,
   transRefLabel,
   NO_TRANS_REFS,
   syncRefLabel,
   NO_SYNC_REFS,
   sftpRefLabel,
   NO_SFTP_REFS,
} from 'common/strings';
import {joinAnd} from 'common/stringUtils';

type ReferencesAlertProps = {
   data: INav;
   objectName: string;
   partners: IPartner[];
   transactions: ITransaction[];
   synchronizations?: IDiplomatObject[];
   sftpServers?: IDiplomatObject[];
   clearAvailable: boolean;
};

const ReferencesAlert = ({
   data,
   objectName,
   partners,
   transactions,
   synchronizations,
   sftpServers,
   clearAvailable,
}: ReferencesAlertProps) => {
   const {t} = useTranslation();
   const {name} = data;
   const items = joinAnd([
      transactions && 'transactions',
      partners && 'partners',
      synchronizations && 'synchronizations',
      sftpServers && 'File Transfer Servers',
   ]);

   return (
      <>
         <Typography variant={'body2'}>
            {t('{{objectName}} "{{name}}" is referenced by one or more partners or transactions.', {
               objectName,
               name,
            })}
         </Typography>
         <Box paddingTop={2}>
            <Panel name={t('Related Partners and Transactions')}>
               <ReferenceItems
                  name={partnerRefLabel(objectName)}
                  data={partners}
                  noData={NO_PARTNER_REFS}
               />
               <ReferenceItems
                  name={transRefLabel(objectName)}
                  data={transactions}
                  noData={NO_TRANS_REFS}
               />
               {synchronizations && (
                  <ReferenceItems
                     name={syncRefLabel(objectName)}
                     data={synchronizations}
                     noData={NO_SYNC_REFS}
                  />
               )}
               {sftpServers && (
                  <ReferenceItems
                     name={sftpRefLabel(objectName)}
                     data={sftpServers}
                     noData={NO_SFTP_REFS}
                  />
               )}
            </Panel>
         </Box>
         <Typography variant={'body2'}>
            <ul>
               <li>
                  {t('Choose DELETE to delete the key and all {{items}} that refer to it.', {
                     items,
                  })}
               </li>
               {clearAvailable && (
                  <li>
                     {t('Choose CLEAR to remove the key reference from all {{items}}', {items})}
                  </li>
               )}
               <li>{t('Choose CANCEL to close this box and do nothing')}</li>
            </ul>
         </Typography>
         {/* <Typography variant={'body2'}>
            {t(
               'Press "Cancel" to manually remove references to "{{name}}" in related partners and transactions before proceeding. (Recommended)',
               {name}
            )}
         </Typography> */}
         {/* <Typography variant={'body2'}>
            {t(
               'Press "OK" to continue with deletion of "{{name}}" and all related partners and transactions.',
               {name}
            )}
         </Typography> */}
      </>
   );
};

export default ReferencesAlert;
